import { render, staticRenderFns } from "./PriceConfKj.vue?vue&type=template&id=6467ba1e"
import script from "./PriceConfKj.vue?vue&type=script&lang=js"
export * from "./PriceConfKj.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports